var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7625 31.2267C35.232 31.6961 35.4957 32.3328 35.4957 32.9967C35.4957 33.6606 35.232 34.2974 34.7625 34.7668C34.2931 35.2363 33.6563 35.5 32.9924 35.5C32.3285 35.5 31.6918 35.2363 31.2224 34.7668L18.0009 21.5412L4.7753 34.7626C4.30585 35.2321 3.66913 35.4958 3.00522 35.4958C2.34131 35.4958 1.7046 35.2321 1.23514 34.7626C0.76569 34.2932 0.501953 33.6565 0.501953 32.9926C0.501953 32.3287 0.76569 31.6919 1.23514 31.2225L14.4608 18.001L1.23931 4.77543C0.769854 4.30598 0.506118 3.66926 0.506118 3.00535C0.506118 2.34144 0.769854 1.70473 1.23931 1.23527C1.70876 0.765819 2.34548 0.502082 3.00939 0.502082C3.6733 0.502082 4.31001 0.765819 4.77947 1.23527L18.0009 14.4609L31.2265 1.23319C31.696 0.763736 32.3327 0.5 32.9966 0.5C33.6605 0.5 34.2972 0.763736 34.7667 1.23319C35.2361 1.70264 35.4999 2.33936 35.4999 3.00327C35.4999 3.66718 35.2361 4.30389 34.7667 4.77335L21.5411 18.001L34.7625 31.2267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerX);
export default __webpack_public_path__ + "static/media/hamburgerX.5a049673f26ce0674dad8b8bd934ff29.svg";
export { ForwardRef as ReactComponent };